var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.998,
    height: 22,
    viewBox: "0 0 21.998 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#1f3f93",
    d: "M21.407 9.568L12.431.593a2.025 2.025 0 0 0-2.864 0L.6 9.562l-.009.009a2.024 2.024 0 0 0 1.348 3.451h.42v6.6A2.373 2.373 0 0 0 4.726 22h3.511a.645.645 0 0 0 .645-.645v-5.178A1.083 1.083 0 0 1 9.963 15.1h2.071a1.083 1.083 0 0 1 1.081 1.081v5.178a.644.644 0 0 0 .645.641h3.511a2.373 2.373 0 0 0 2.371-2.37v-6.6h.332a2.025 2.025 0 0 0 1.433-3.457zm0 0",
    transform: "translate(0 .001)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.2207d386e1e0493e1e596a0490855e3c.svg";
export { ForwardRef as ReactComponent };